export default __webpack_public_path__ + "static/media/pebble.ec0ece4a.svg";